var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _linearGradient2, _path9, _linearGradient3, _path10, _linearGradient4, _path11, _linearGradient5, _path12, _linearGradient6, _path13, _linearGradient7, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeductions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.48,
    y1: -249.097,
    x2: 1280.48,
    y2: -249.097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M63.738 85.759l20.974.027M92.729 85.759l4.686.027M63.528 38.518l34.865.036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.044 85.759l33.551.027M98.055 38.518l34.865.036M142.86 75.841l.014-27.342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M53.638 75.581l-.083-27.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M132.94 38.554c-.003 5.487 4.448 9.942 9.935 9.945"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M63.528 38.518c-.003 5.487-4.458 9.938-9.945 9.935M53.588 75.676c5.487.003 9.938 4.458 9.935 9.945"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M142.86 75.841c-5.487-.003-9.942 4.448-9.945 9.945"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.895,
    cy: 62.054,
    r: 4.293
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 65.491,
    cy: 62.021,
    r: 4.293
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M96.438 94.162h55.131V29.667H98.555"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M98.555 29.667h-53.29v64.495h42.053"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 83.478,
    y1: 98.117,
    x2: 118.602,
    y2: 98.117,
    xlinkHref: "#SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M98.206 99.046L85.689 70.465S83.902 77.256 85.2 86.1c1.841 10.309 8.765 16.5 8.765 16.5s-4.909 7.364-4.909 13.745c0 6.382 2.985 11.123 9.336 8.843 5.619-2.199 2.936-18.661 2.936-18.661s2.441 16.038 10.309 16.2c8.093.167 5.798-8.415 3.856-12.685-3.094-5.863-10.261-10.749-10.261-10.749l.977-4.56",
    stroke: "url(#SVGID_1_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 105.123,
    y1: 111.996,
    x2: 113.486,
    y2: 111.996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6C3393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#AD1C7C"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)",
    d: "M106.373 107.11l5.863 9.772"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 93.885,
    y1: 113.462,
    x2: 97.607,
    y2: 113.462,
    xlinkHref: "#SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_3_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)",
    d: "M96.357 107.599l-1.222 11.726"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 91.405,
    y1: 58.96,
    x2: 99.558,
    y2: 58.96,
    xlinkHref: "#SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_4_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)",
    d: "M98.308 61.105l-5.653-4.291"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 91.941,
    y1: 68.477,
    x2: 99.916,
    y2: 68.477,
    xlinkHref: "#SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M93.191 65.736s.944 5.478 5.475 5.48",
    stroke: "url(#SVGID_5_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62",
    gradientUnits: "userSpaceOnUse",
    x1: 91.405,
    y1: 54.077,
    x2: 99.656,
    y2: 54.077,
    xlinkHref: "#SVGID_0_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M98.406 51.34c-4.531-.002-5.751 5.475-5.751 5.475",
    stroke: "url(#SVGID_6_5085549572aceab964b5a12906139c8832e0bb5127517c81edc9c234d9863e62)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M98.308 61.105l-5.653-4.291M93.191 65.736s.944 5.478 5.475 5.48M98.406 51.34c-4.531-.002-5.751 5.475-5.751 5.475"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.397 71.612c4.531.002 5.751-5.475 5.751-5.475l-6.11-4.637M104.521 56.593s-.944-5.478-5.475-5.48M98.8 30.988v9.445M98.8 47.157v9.446M98.8 66.22v9.445M98.8 82.17v9.445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeductions);
export default __webpack_public_path__ + "static/media/deductions.c569c3216d20f58fa7561ceec3a599f7.svg";
export { ForwardRef as ReactComponent };